export const WeeklyReportItemTypes = Object.freeze({
    MOBILIDADE: 1,
    CUIDADOS_PESSOAIS: 2,
    ATIVIDADES_HABITUAIS: 3,
    DOR_DESCONFORTO: 4,
    ANSIEDADE_DEPRESSAO: 5,
    NIVEL_DE_ANGUSTIA: 6
  });
  